// MobileWizardFooter — sticky bottom Back / Next bar that takes over wizard
// navigation in mobile mode. Pages can pass custom labels per step (e.g.
// "Submit Order" on the last step).

import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

export const MobileWizardFooter = ({
  onBack,
  onNext,
  backLabel = "Back",
  nextLabel = "Next",
  nextDisabled = false,
  backDisabled = false,
  nextLoading = false,
  nextVariant = "primary", // "primary" | "submit"
  hideBack = false,
  hideNext = false,
  testId = "mobile-wizard-footer",
}) => {
  const nextBgClass =
    nextVariant === "submit"
      ? "bg-emerald-500 hover:bg-emerald-400 text-white"
      : "bg-amber-500 hover:bg-amber-400 text-white";

  return (
    <div
      className="pos-wizard-footer fixed bottom-0 left-0 right-0 z-40 hidden border-t border-white/10 bg-[#111c2e]/95 px-3 py-2 backdrop-blur supports-[backdrop-filter]:bg-[#111c2e]/80"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)" }}
      data-testid={testId}
    >
      <div className="mx-auto flex max-w-3xl items-center gap-2">
        {!hideBack && (
          <button
            type="button"
            onClick={onBack}
            disabled={backDisabled}
            className="flex h-12 flex-1 items-center justify-center gap-2 rounded-lg border border-white/15 bg-white/5 text-sm font-semibold text-white transition active:scale-[0.98] disabled:opacity-40"
            data-testid={`${testId}-back`}
          >
            <ArrowLeft size={16} />
            {backLabel}
          </button>
        )}
        {!hideNext && (
          <button
            type="button"
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
            className={`flex h-12 flex-[1.5] items-center justify-center gap-2 rounded-lg text-sm font-semibold transition active:scale-[0.98] disabled:opacity-50 disabled:active:scale-100 ${nextBgClass}`}
            data-testid={`${testId}-next`}
          >
            {nextLoading && (
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
            )}
            {!nextLoading && nextLabel}
            {!nextLoading && nextVariant !== "submit" && <ArrowRight size={16} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileWizardFooter;
